import { type JoinEventDataObject } from './service';

export const createJoinEvent = (joinEvent: JoinEventDataObject): JoinEvent => ({
  enterUri: joinEvent.enter_uri,
});

export type JoinEvent = {
  enterUri: string;
};
